<template>
    <div class="category-list-view">
        <div class="description">
            {{ $t("chatbotv2.thereAreOnePages") }}
            <strong>{{ category }}</strong>
            {{ $t("chatbotv2.categoryDesc") }}
        </div>
        <div class="list">
            <div class="item" v-for="page of pages">
                <div class="left" @click="() => gotoPage(page)">
                    <div class="title">{{ page.title }}</div>
                    <div class="url">
                        <i class="material-icons">link</i>
                        {{ page.url }}
                    </div>
                </div>
                <div class="right">
                    <a-switch :checked="isSelected(page)" @click="toggle(page)" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import Modal2 from "../../../../components/common/Modal2.vue";
import _ from "lodash";

export default Vue.extend({
    name: "CategoryPageListView",
    components: { Modal2 },
    props: {
        category: String,
        pages: Array,
        value: Array,
    },

    data() {
        return {
            clone: _.cloneDeep(this.value),
        };
    },
    methods: {
        isSelected(page) {
            return !this.clone.includes(page.url);
        },
        toggle(page) {
            if (this.isSelected(page)) {
                this.clone.push(page.url);
            } else {
                this.clone = this.clone.filter((url) => url !== page.url);
            }
            this.clone = _.uniq(this.clone);
        },
        gotoPage(page) {
            window.open(page.url, "_blank");
        },
    },
    watch: {
        clone() {
            console.log("clone changed", this.clone);
            this.$emit("input", this.clone);
        },
        value() {
            console.log("value changed", this.value);
            if (!_.isEqual(this.value, this.clone)) this.clone = _.cloneDeep(this.value);
        },
    },
});
</script>

<style scoped lang="scss">
.category-list-view {
    .list {
        display: flex;
        flex-direction: column;
        gap: 10px;

        .item {
            align-items: center;
            background: #f5f5f5;
            border-radius: 10px;
            display: flex;
            height: 46px;
            padding: 0 20px;
            cursor: pointer;
            width: 100%;

            .right {
                width: 50px;
            }

            .left {
                width: calc(100% - 50px);

                .url {
                    display: none;
                }
            }

            &:hover {
                background: #ededed;

                .title {
                    display: none;
                }

                .url {
                    color: var(--color-text-primary-default);
                    display: flex;
                    gap: 5px;
                    align-items: center;
                }
            }
        }
    }
}
</style>
